import type { SupersetChartData } from "../../../api/supersetApi";

export interface PivotedSeries {
	name: string;
	points: { x: string; y: number }[];
}

export interface PivotedChart {
	categories: string[];
	series: PivotedSeries[];
}

export function pivotChartData(data: SupersetChartData): PivotedChart {
	const { rows, xField, seriesField, valueField } = data;
	if (!valueField) return { categories: [], series: [] };

	const categoryOrder: string[] = [];
	const seriesOrder: string[] = [];
	const bySeries = new Map<string, Map<string, number>>();

	for (const row of rows) {
		const category = xField ? String(row[xField] ?? "") : "value";
		const series = seriesField ? String(row[seriesField] ?? "") : "value";
		const value = Number(row[valueField] ?? 0);

		if (!categoryOrder.includes(category)) categoryOrder.push(category);
		if (!seriesOrder.includes(series)) seriesOrder.push(series);

		let seriesValues = bySeries.get(series);
		if (!seriesValues) {
			seriesValues = new Map();
			bySeries.set(series, seriesValues);
		}
		seriesValues.set(category, value);
	}

	const series = seriesOrder.map((name) => ({
		name,
		points: categoryOrder.map((category) => ({
			x: category,
			y: bySeries.get(name)?.get(category) ?? 0,
		})),
	}));

	return { categories: categoryOrder, series };
}
